var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 2.25V9.25H2.25C1.2835 9.25 0.5 10.0335 0.5 11C0.5 11.9665 1.2835 12.75 2.25 12.75H9.25V19.75C9.25 20.7165 10.0335 21.5 11 21.5C11.9665 21.5 12.75 20.7165 12.75 19.75V12.75H19.75C20.7165 12.75 21.5 11.9665 21.5 11C21.5 10.0335 20.7165 9.25 19.75 9.25H12.75V2.25C12.75 1.2835 11.9665 0.5 11 0.5C10.0335 0.5 9.25 1.2835 9.25 2.25Z",
    fill: "#E3E6F1",
    stroke: "#0A0C17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAim);
export default __webpack_public_path__ + "static/media/aim.7693fc364b036ed06db6d0d3327dfb69.svg";
export { ForwardRef as ReactComponent };